var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 24.75C5.11042 24.75 4.78408 24.618 4.521 24.354C4.257 24.0909 4.125 23.7646 4.125 23.375C4.125 22.9854 4.257 22.6591 4.521 22.396C4.78408 22.132 5.11042 22 5.5 22H27.5C27.8896 22 28.2159 22.132 28.479 22.396C28.743 22.6591 28.875 22.9854 28.875 23.375C28.875 23.7646 28.743 24.0909 28.479 24.354C28.2159 24.618 27.8896 24.75 27.5 24.75H5.5ZM5.5 17.875C5.11042 17.875 4.78408 17.743 4.521 17.479C4.257 17.2159 4.125 16.8896 4.125 16.5C4.125 16.1104 4.257 15.7836 4.521 15.5196C4.78408 15.2565 5.11042 15.125 5.5 15.125H27.5C27.8896 15.125 28.2159 15.2565 28.479 15.5196C28.743 15.7836 28.875 16.1104 28.875 16.5C28.875 16.8896 28.743 17.2159 28.479 17.479C28.2159 17.743 27.8896 17.875 27.5 17.875H5.5ZM5.5 11C5.11042 11 4.78408 10.8685 4.521 10.6054C4.257 10.3414 4.125 10.0146 4.125 9.625C4.125 9.23542 4.257 8.90863 4.521 8.64463C4.78408 8.38154 5.11042 8.25 5.5 8.25H27.5C27.8896 8.25 28.2159 8.38154 28.479 8.64463C28.743 8.90863 28.875 9.23542 28.875 9.625C28.875 10.0146 28.743 10.3414 28.479 10.6054C28.2159 10.8685 27.8896 11 27.5 11H5.5Z",
    fill: "url(#paint0_linear_1973_1251)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1973_1251",
    x1: 4.125,
    y1: 16.5,
    x2: 28.875,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3154C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburger_icon.000b459ad23a91d3229b7075594f7267.svg";
export { ForwardRef as ReactComponent };